module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-view login-form"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('actions.login.title')))]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "emailOrCellphone",
      "error": _vm.errors.first('emailOrCellphone')
    }
  }, [_c('el-input', {
    attrs: {
      "name": "ppj-account",
      "placeholder": _vm.$t('placeholder.user.emailOrCellphone')
    },
    model: {
      value: (_vm.form.emailOrCellphone),
      callback: function($$v) {
        _vm.form.emailOrCellphone = $$v
      },
      expression: "form.emailOrCellphone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "error": _vm.errors.first('password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('placeholder.user.password')
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.form.password = $$v
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary submit-btn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.signIn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.login.login')))])], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "left"
  }, [_c('router-link', {
    attrs: {
      "to": "/wxlogin"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-wechat",
    staticStyle: {
      "margin-right": "0.5em"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('actions.login.wxlogin')) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.login.register')))]), _vm._v(" |\n        "), _c('router-link', {
    attrs: {
      "to": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.login.password')))])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19d9d167"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/session/login.view.vue
// module id = 902
// module chunks = 3